// extracted by mini-css-extract-plugin
export var inlineLink = "_a5-0";
export var inlineLinkButton = "_a5-1";